import GoogleIcon from "../../assets/images/googleicon.svg"
import { useGoogleLogin } from "@react-oauth/google"
import { Space } from "antd"
import { LoadingOutlined } from "@ant-design/icons"

type Props = {
  /** This provider's sign-in is in flight: show the spinner. */
  loading: boolean
  /**
   * Some other sign-in is in flight. The button refuses clicks but keeps its face -- a spinner
   * here would claim this provider is working when it is not.
   */
  disabled?: boolean
  onProviderLogin: (provider: string, auth_code: string) => void
}

export const GoogleLogin = ({
  loading,
  disabled = false,
  onProviderLogin,
}: Props) => {
  const googleLogin = useGoogleLogin({
    flow: "implicit",
    onSuccess: (codeResponse) => {
      onProviderLogin("google", codeResponse?.access_token)
    },
    onError(errorResponse) {
      console.log(errorResponse.error_description)
    },

    enable_serial_consent: true,
  })

  return (
    <div
      className={`flex flex-col items-center ${
        disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"
      }`}
      onClick={(e) => {
        e.preventDefault()
        if (loading || disabled) return
        googleLogin()
      }}
    >
      {loading ? (
        <div className="flex gap-2 items-center">
          <div className="invisible ">
            <img
              src={GoogleIcon}
              alt="googleicon"
            />
          </div>
          <span>
            <Space>
              <LoadingOutlined size={20} />
            </Space>
          </span>
        </div>
      ) : (
        <>
          <div>
            <img
              src={GoogleIcon}
              alt="googleicon"
            />
          </div>
          <div className="mt-[8px] font-ibm font-medium text-[16px] leading-[20.8px] text-neutral700">
            Google
          </div>
        </>
      )}
    </div>
  )
}
